import { useRef } from 'react'

import { NotesTextEditor } from '@factorialco/f0-react/dist/experimental'

import { useImageUploadForEditor } from 'modules/core/hooks/useImageUploadForEditor'
import i18n from 'modules/core/lib/i18n'

const RESOURCE_TYPE = 'Trainings::Training'

export type InlineEditableContentProps = {
  value: string
  readOnly: boolean
  onChange: (value: string) => void
  title: string
  onTitleChange: (value: string) => void
  trainingId: string
}

export const InlineEditableContent = ({
  value,
  readOnly,
  onChange,
  title,
  onTitleChange,
  trainingId,
}: InlineEditableContentProps) => {
  const lastTitleRef = useRef(title)
  const lastValueRef = useRef(value)

  const { onUpload } = useImageUploadForEditor({
    resourceType: RESOURCE_TYPE,
    resourceId: trainingId,
  })

  const parseDescriptionContent = (description: string) => {
    if (!description) return ''
    try {
      return JSON.parse(description)
    } catch {
      return description
    }
  }

  const handleTitleChange = (newTitle: string) => {
    if (newTitle !== lastTitleRef.current) {
      lastTitleRef.current = newTitle
      onTitleChange(newTitle)
    }
  }

  const handleContentChange = (json: unknown) => {
    const newValue = JSON.stringify(json)
    if (newValue !== lastValueRef.current) {
      lastValueRef.current = newValue
      onChange(newValue)
    }
  }

  return (
    <NotesTextEditor
      initialEditorState={{
        content: parseDescriptionContent(value),
        title: title,
      }}
      onTitleChange={readOnly ? undefined : handleTitleChange}
      placeholder={i18n.t('trainings.content.block.page.description_placeholder')}
      onChange={({ json }) => handleContentChange(json)}
      readonly={readOnly}
      showBubbleMenu={!readOnly}
      imageUploadConfig={{ onUpload }}
      titlePlaceholder={i18n.t('trainings.content.block.page.title_placeholder')}
    />
  )
}
